import * as flexsearch from "flexsearch";

class DataService<T extends flexsearch.DocumentData> {
    protected static SEARCH_QUERY_SIZE: number = 500;

    protected _index: flexsearch.Document<T>;

    protected _indexPreparedForWorkspaceId: string;
    protected _prepareIndexPromise: Promise<void>;

    protected _prepareIndex(workspaceId: string): Promise<void> {
        throw new Error("Not implemented");
    }

    public async ensureIndexPrepared(workspaceId: string) {
        if (this._indexPreparedForWorkspaceId === workspaceId) {
            await this._prepareIndexPromise;
            return;
        }

        this._indexPreparedForWorkspaceId = workspaceId;
        this._prepareIndexPromise = this._prepareIndex(workspaceId);
        return this._prepareIndexPromise;
    }

    public async dispose() {
        this._prepareIndexPromise = null;
        this._indexPreparedForWorkspaceId = null;
        this._index = null;
    }
}

export default DataService;
